import type { TrackedPromise } from '@remix-run/router';
import { LoadingPage } from '@src/common/components/LoadingPage';
import { Navigation } from '@src/routing/Navigation';
import type { ComponentProps } from 'react';
import { Suspense } from 'react';
import { Await, Navigate, useLoaderData, useLocation } from 'react-router-dom';

export const AwaitRouterData = ({
  children,
  path,
}: Omit<ComponentProps<typeof Await>, 'resolve'> & {
  path: string;
}) => {
  const data = useLoaderData() as Awaited<Record<string, TrackedPromise>>;
  const { pathname } = useLocation();

  return (
    <Suspense key={pathname} fallback={<LoadingPage />}>
      <Await
        resolve={data[path]}
        children={children}
        errorElement={<Navigate replace to={Navigation.home} />}
      />
    </Suspense>
  );
};
